import type { BaseController } from '@infra/controllers/base.controller';
import type { BlindTransferNumberUsecase } from './blind-transfer-call.usecase';

export type TransferNumberInput = {
  callId: string;
  phoneNumber: string;
  name?: string;
};

export type TransferNumberOutput = void;

export class BlindTransferNumberController
  implements BaseController<TransferNumberInput, TransferNumberOutput>
{
  constructor(private usecase: BlindTransferNumberUsecase) {}

  async handle({
    callId,
    phoneNumber: to,
    name,
  }: TransferNumberInput): Promise<TransferNumberOutput> {
    await this.usecase.run({ callId, to, name });
  }
}
